export function getSavedCardSystemLogo(system: string) {
  switch (system.toLowerCase()) {
    case 'visa':
      return 'visa';
    case 'mastercard':
    case 'master card':
      return 'mastercard';
    case 'maestro':
      return 'maestro';
    default:
      return '';
  }
}
